module.exports = __webpack_public_path__ + "static/media/login-spinner.8648ca95.svg";